var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ag-cell-list-item"},[_c('a',{staticClass:"ag-cell-click cell-centered",on:{"click":_vm.showDetail}},[(_vm.nextVisit)?_c('span',[_vm._v(_vm._s(_vm.visitDate)+"\n    ")]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }